<div class="avatar-container {{size()}}">
  @if(getPicture()) {
    <img class="user-avatar" [src]="getPicture()" [alt]="getFullName()">
  } @else {
    <mat-icon class="icon--color--gray">account_circle</mat-icon>
  }
</div>
